<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6l08mN/Images/cover.jpg?1685327561453" alt="This image is the cover for the book When the Planets Align"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When the Planets Align
      </h1>
      <p class="bookDescription body article font2">
        <p>Best friends Michael Reeves and Simon Newell always lived within ten minutes of each other, but somehow they’re never in the same place at the same time.</p> <p>Brash, outgoing Michael’s unwavering confidence that he and Simon are meant to be carries him through some hard times. When Simon moves to New York, Michael dutifully follows. Quiet, practical Simon loves Michael as a dear friend, but he’s not ready for anything romantic.</p> <p>Several years and several failed relationships later, Simon realizes he’s been in love with Michael all along. Only now Michael has moved on. Though Simon offers everything Michael’s ever dreamed of, the timing is all wrong. Confusion, betrayal, and secrets from the past threaten their friendship until it might be time for them to go their separate ways. Or maybe the planets will finally align, and Michael and Simon will find themselves in the right place at the right time to take the next step.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate McMurray
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fbc1254c